import { render, staticRenderFns } from "./SelectorTree.vue?vue&type=template&id=4173dab0&"
import script from "./SelectorTree.vue?vue&type=script&lang=js&"
export * from "./SelectorTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports